import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LatestSales, DashboardData } from '../../../../@core/data/dashboard-data';

@Component({
  selector: 'ngx-latest-sales',
  styleUrls: ['./latest-sales.component.scss'],
  templateUrl: './latest-sales.component.html',
})
export class LatestSalesComponent implements OnDestroy {
  transactionsData: LatestSales[];
  constructor(private dashboardData: DashboardData,
    private route: ActivatedRoute
  ) {
    this.getLatest7Transactions();
  }

  getLatest7Transactions() {
    this.route.params
      .subscribe(params => {
        this.dashboardData.getLatest7Transactions(params.oid, params.gid)
          .subscribe(data => {
            this.transactionsData = data;
          });
      });
  }

  ngOnDestroy() {
  }
}
